import { render } from "./modal-basic.vue?vue&type=template&id=23f31a96"
import script from "./modal-basic.vue?vue&type=script&lang=js"
export * from "./modal-basic.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vc4a/vc4a/wp-content/themes/vc4africa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__